'use client';

import { useEffect } from 'react';
import showApiError from '~/utilities/flp/showApiError';

/**
 * The validation itself is already logged server-side by
 * validatePricingAggregates — this only owns the client-side toast, so a
 * single validation failure produces one log and one toast, not two.
 */
export default function ValidationFailureToast() {
  useEffect(() => {
    showApiError();
  }, []);

  return null;
}
